// extracted by mini-css-extract-plugin
module.exports = {"cursor":"BookingDateRangeFilter_cursor__2dXu6","popupSize":"BookingDateRangeFilter_popupSize__3IFh0"};